import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Suspense } from 'react';

import './vendor/bootstrap-5.3.0-alpha1-dist/css/bootstrap.min.css'
import './assets/css/style.css'
import Loader from './Common/Loader';
import AuthRoute from './Authentication/AuthRoute';
import WithoutAuthRoute from './Authentication/WithoutAuthRoute';
import BusinessRoute from './Authentication/BusinessRoute';

const Login = React.lazy(() => import('./Login/Login'))
const VerifyOtp = React.lazy(() => import('./Login/VerifyOtp'))
const SelectBusiness = React.lazy(() => import('./Login/SelectBusiness'))
const Dashboard = React.lazy(() => import('./Dashboard/Dashboard'))
const Issues = React.lazy(() => import('./Issues/Issues'))
const ViewIssue = React.lazy(() => import('./Issues/ViewIssue'))
const Contacts = React.lazy(() => import('./Contacts/Contacts'))
const ReviewUs = React.lazy(() => import('./ReviewUs/ReviewUs'))

function App() {
  const domain = window.location.origin;
  // console.log('domain', domain);
  return (
    <div>
      <BrowserRouter basename='/customer'>
        <ToastContainer />
        <Suspense fallback={<Loader />}>

          <Routes>

            <Route element={<WithoutAuthRoute />}>
              <Route path='/' element={<Login />} />
              <Route path='/verify-otp' element={<VerifyOtp />} />
            </Route>

            <Route element={<AuthRoute />}>
              {/* <Route path='/select-business' element={<SelectBusiness />} /> */}
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='/issues' element={<Issues />} />
              <Route path='/issues/:id' element={<ViewIssue />} />
              <Route path='/contacts' element={<Contacts />} />
              <Route path='/review-us' element={<ReviewUs />} />

            </Route>

            <Route element={<BusinessRoute />}>
              <Route path='/select-business' element={<SelectBusiness />} />
            </Route>

          </Routes>

        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
